import Text from '@deprecated-ui/common/Text';
import color from '@deprecated-ui/_style/color';
import { useRouter } from 'next/router';
import { AlertContainer, DepositButton } from '../styled';
import { useBondsModalStore } from '../../../stores/useBondsModalStore';

export default function DepositAlert() {
  const router = useRouter();
  const closeTransactionModal = useBondsModalStore(
    (s) => s.closeTransactionModal,
  );
  const onDepositClick = () => {
    closeTransactionModal();
    router.push('/securities/deposit');
  };
  return (
    <AlertContainer>
      <div>
        {/* @ts-expect-error */}
        <Text family="bold" mb="2px">
          Deposit Sekarang
        </Text>
        <Text color={color.sunsetOrange}>Saldo kamu tidak mencukupi</Text>
      </div>
      <DepositButton onClick={onDepositClick}>Deposit</DepositButton>
    </AlertContainer>
  );
}
